import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';

export const initialState = {
    ipWhiteListData: [],
    loading: false,
    drawerOpen: false,
    selectedRow: null,
    isEditMode: false,
};

export const getColumns = (t: any): ExtendedGridColDef[] => [
    {
        field: 'id',
        headerName: t('general.id'),
        flex: 0.5,
        minWidth: 80,
    },
    {
        field: 'ipAddress',
        headerName: t('ipWhiteList.ipAddress'),
        flex: 1,
        minWidth: 150,
    },
    {
        field: 'description',
        headerName: t('general.description'),
        flex: 2,
        minWidth: 200,
    },
    {
        field: 'createdAt',
        headerName: t('ipWhiteList.createdDate'),
        flex: 1,
        minWidth: 150,
        valueFormatter: (params: any) => {
            if (!params.value) return '';
            return new Date(params.value).toLocaleDateString('tr-TR');
        },
    },
    {
        field: 'updatedAt',
        headerName: t('ipWhiteList.updatedDate'),
        flex: 1,
        minWidth: 150,
        valueFormatter: (params: any) => {
            if (!params.value) return '';
            return new Date(params.value).toLocaleDateString('tr-TR');
        },
    },
];

export const validateIpAddress = (ip: string): boolean => {
    const ipRegex =
        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    return ipRegex.test(ip);
};
